// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__xGNqJ","header":"Error_header__UJerU","title":"Error_title__m3iTd"};